// Flow service
import { fetchData } from '../../fetchapi/fetchapi.js';

export const runEndpoint = async (endpointName, params) => {
  return await fetchData('flow', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      endpoint: endpointName,
      input: params
    }),
  });
};
